module.exports = __webpack_public_path__ + "assets/img/wszdh.37132249.png";